// SEC-002 — XSS sanitiser sweep. Every place we render staff- or client-authored
// HTML via dangerouslySetInnerHTML MUST go through this to defang <script>,
// event handlers (onclick/onerror), javascript: URIs, etc.
//
// Usage:
//   <div dangerouslySetInnerHTML={{ __html: safeHtml(userAuthoredHtml) }} />
import DOMPurify from 'dompurify';

// Conservative allow-list: rich text needed for eSign letters, letters, portal
// notifications and branding preview. Blocks scripts, event handlers, iframes,
// object/embed, form submits.
const RICH_TEXT_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'span', 'div', 'strong', 'em', 'b', 'i', 'u', 's', 'sub', 'sup',
    'blockquote', 'pre', 'code', 'hr',
    'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'a', 'img',
    'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption', 'colgroup', 'col',
  ],
  ALLOWED_ATTR: [
    'href', 'src', 'alt', 'title', 'target', 'rel',
    'colspan', 'rowspan', 'align', 'valign',
    'style', 'class',
  ],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|data:image\/(?:png|jpeg|jpg|gif|svg\+xml)):|[^:]*$)/i,
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'style'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'formaction'],
};

// Force target="_blank" links to also carry rel="noopener noreferrer".
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export function safeHtml(input) {
  if (input == null) return '';
  return DOMPurify.sanitize(String(input), RICH_TEXT_CONFIG);
}

// Stricter mode — plain text only, HTML tags stripped completely.
export function stripHtml(input) {
  if (input == null) return '';
  return DOMPurify.sanitize(String(input), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}
